import styled from 'styled-components';

export const DownloadAllButton = styled.button.attrs({
  type: 'button',
  className: 'nodrag nopan',
})`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: transparent;
  border: none;
  color: ${({ theme: { colors = {} } }) => colors.primary ?? '#C1C1FF'};
  cursor: pointer;
  font: inherit;
  font-size: 11px;
  font-weight: 600;
  padding: 0;
  white-space: nowrap;

  &:hover:not(:disabled) {
    text-decoration: underline;
  }

  &:disabled {
    cursor: progress;
    opacity: 0.6;
  }

  &:focus-visible {
    outline: 2px solid
      ${({ theme: { colors = {} } }) => colors.primary ?? '#C1C1FF'};
    outline-offset: 2px;
  }
`;
